module.exports = __webpack_public_path__ + "img/Red-L-3@2x.ebd48e36.png";